
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  ConfigResetActionDto,
  ConfigResetListDto, ConfigResetRepositoryInterface, RestoreTaskId,
  RestoreTaskRepositoryInterface,
  RestoreTaskSummaryDto,
} from "@/services/Backup/interfaces";

@Component({
  inject: ['restoreTaskRepository', 'configResetRepository'],
})
export default class RestoreTaskDetailsDialog extends Vue {
  public restoreTaskRepository: RestoreTaskRepositoryInterface;
  public configResetRepository: ConfigResetRepositoryInterface;

  public loading = false;

  @Prop()
  public restoreTask: RestoreTaskSummaryDto | null;
  @Prop()
  public configRestoreData: ConfigResetListDto | null;

  private timeout?: any;

  public actionStatusIconMap: { [key: string]: string } = {
    'scheduled': 'mdi-progress-clock',
    'pending': 'mdi-progress-helper',
    'Pending': 'mdi-progress-clock',
    'in progress': 'mdi-progress-helper',
    'Running': 'mdi-progress-helper',
    'failed': 'mdi-close-thick',
    'Failed': 'mdi-close-thick',
    'done': 'mdi-check',
    'Finished': 'mdi-check',
    'done not restored': 'mdi-check',
  };

  public configResetStatusLabels: { [key: string]: string } = {
    'pending': 'Configuration restore is running',
    'failed': 'Failed restore of configuration',
    'done': 'Successfully restore configuration',
  };

  public statusLabels: { [key: number]: string } = {
    0: 'Pending',
    1: 'Running',
    2: 'Finished',
    3: 'Failed',
  };

  public configVisible: boolean = false;
  public logsVisible: boolean = false;
  public selectedConfigResetAction: ConfigResetActionDto | null = null;

  public statusLabel(status: number): string {
    return this.statusLabels[status] || 'Unknown';
  }

  public snapshotTargetLabel(status: number, type?: string): string {
    if (!type) {
      switch (status) {
        case 0: return 'Server restore for website is waiting for configurations to be restored.';
        case 1: return 'Server restore for website is in progress...';
        case 2: return 'Server restore for website executed successfully';
        case 3: return 'Server restore for website failed during execution';
      }
    } else {
      switch (status) {
        case 0: return 'Restore of ' + type[0].toUpperCase() + type.substring(1) + ' is waiting for configurations to be restored.';
        case 1: return 'Restore of ' + type[0].toUpperCase() + type.substring(1) + ' is in progress...';
        case 2: return 'Restore of ' + type[0].toUpperCase() + type.substring(1) + ' executed successfully';
        case 3: return 'Restore of ' + type[0].toUpperCase() + type.substring(1) + ' failed during execution';
      }
    }
  }

  public snapshotLabelNumber(targets: {status: number}[]): number {
    const reverseIndex = targets.reduce((index, target) => {
      if (!index[target.status]) {
        index[target.status] = 0;
      }
      index[target.status]++;

      return index;
    }, {} as {[index: number]: number});

    if (reverseIndex[3] > 0) {
      return 3;
    } else if (reverseIndex[1] > 0) {
      return 1;
    } else if (reverseIndex[2] > 0) {
      return 2;
    }

    return 0;
  }

  public snapshotLabel(targets: {status: number}[]): string {
    return this.snapshotTargetLabel(this.snapshotLabelNumber(targets));
  }

  public typeLabel(type: number): string {
    const typeLabels: { [key: number]: string } = {
      0: 'Config/Server',
      1: 'Server',
      2: 'Config',
    };
    return typeLabels[type] || 'Unknown';
  }

  public created(): void {
    //return this.scheduleReload();
  }

  public destroyComponent(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.$emit('close');
  }

  public showConfig(selectedConfigResetAction: ConfigResetActionDto): void {
    this.selectedConfigResetAction = selectedConfigResetAction;
    if (this.selectedConfigResetAction) {
      this.selectedConfigResetAction.config = JSON.parse(this.selectedConfigResetAction.config)
    }

    this.configVisible = true;
  }

  public showLogs(selectedConfigResetAction: ConfigResetActionDto): void {
    this.selectedConfigResetAction = selectedConfigResetAction;
    this.logsVisible = true;
  }

  public toggle(websiteId: number): void {
    const element = document.getElementById(`website-config-${websiteId}`);
    if (!element) {
      return;
    }

    for (const elementElement of document.getElementsByClassName("website-config")) {
      if (elementElement.classList.contains("d-none") || elementElement === element) continue;

      elementElement.classList.add("d-none");
    }

    element.classList.toggle('d-none');
  }

  public toggleSnapshots(websiteId: number): void {
    const element = document.getElementById(`website-snapshots-${websiteId}`);
    if (!element) {
      return;
    }

    for (const elementElement of document.getElementsByClassName("website-config")) {
      if (elementElement.classList.contains("d-none") || elementElement === element) continue;

      elementElement.classList.add("d-none");
    }

    element.classList.toggle('d-none');
  }

  public scheduleReload(): void {
    this.timeout = setTimeout(async args => {
      this.$emit("refresh");

      this.scheduleReload();
    }, 2000);
  }

}
